import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import style from './style.scss';

export const ButtonLink = ({
  className = '',
  children = null,
  onClick = () => {},
  ...rest
}) => (
  <button
    className={cn(className, style.button)}
    onClick={onClick}
    {...rest}
  >
    {children}
  </button>
);

ButtonLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  onClick: PropTypes.func,
};

export default ButtonLink;
